// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"az_hk","topHrTag":"az_ik","bottomHrTag":"az_jk","linksAndCookieBtn":"az_kk"};